@import '../../utils/choice-list.css';
@import '../../utils/visually-hidden.css';
@import '../../styles/control-elevation.css';

:host {
  display: block;
  box-sizing: border-box;
  -webkit-user-select: none;
  user-select: none;
}

:host(:focus-within),
:host(.conversation-list-item--actions-open) {
  position: relative;
  z-index: var(--dimension-z-index-floating);
}

.conversation-list-item__row {
  position: relative;
  isolation: isolate;
}

.conversation-list-item {
  color: var(--color-foreground-primary);
}

.conversation-list-item--error {
  --ds-interaction-border-width: var(--dimension-stroke-width-012);
  --ds-interaction-border-color: var(--color-border-bold-negative);
}

.conversation-list-item__leading:empty,
.conversation-list-item__trailing:empty {
  display: none;
}

.conversation-list-item__leading,
.conversation-list-item__trailing,
.conversation-list-item__preview-row {
  display: flex;
  align-items: center;
}

.conversation-list-item__leading {
  align-self: center;
  width: auto;
  height: auto;
  margin-inline-start: var(--ds-control-label-inset, var(--dimension-space-025));
  margin-inline-end: var(--dimension-space-050);
}

.conversation-list-item__content {
  min-width: 0;
}

.conversation-list-item__title-row {
  display: flex;
  align-items: center;
  min-width: 0;
}

.conversation-list-item__preview-row {
  min-width: 0;
  gap: var(--dimension-space-050);
}

ds-text.conversation-list-item__title,
ds-text.conversation-list-item__preview {
  display: block;
  min-width: 0;
}

ds-text.conversation-list-item__title {
  flex: 1;
}

.conversation-list-item__unread {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: var(--dimension-size-200);
  margin-inline-end: var(--dimension-space-025);
}

ds-text.conversation-list-item__preview.ds-choice-item__subtext {
  -webkit-line-clamp: 1;
}

.conversation-list-item__actions {
  position: absolute;
  top: 50%;
  right: var(--dimension-space-100);
  z-index: var(--dimension-z-index-floating);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--dimension-radius-half);
  background: var(--color-background-transparent);
  -webkit-backdrop-filter: blur(var(--effect-blur-sm));
  backdrop-filter: blur(var(--effect-blur-sm));
  opacity: 0;
  pointer-events: none;
  transform: translateY(-50%);
}

.conversation-list-item__row:has(:focus-visible) .conversation-list-item__actions,
:host(.conversation-list-item--actions-open) .conversation-list-item__actions {
  opacity: 1;
  pointer-events: auto;
}

:host(.conversation-list-item--actions-open) .conversation-list-item::after {
  background: var(--ds-interaction-hover);
}

.conversation-list-item__row:active .conversation-list-item::after {
  background: var(--ds-interaction-pressed);
}

@media (hover: hover) and (pointer: fine) {
  :host(:hover) {
    position: relative;
    z-index: var(--dimension-z-index-floating);
  }

  .conversation-list-item__row:hover .conversation-list-item__actions {
    opacity: 1;
    pointer-events: auto;
  }

  /* Keep the row wash continuous while the pointer moves onto its sibling action. */
  .conversation-list-item__row:hover .conversation-list-item::after {
    background: var(--ds-interaction-hover);
  }
}

@media (hover: none) {
  .conversation-list-item__actions {
    opacity: 1;
    pointer-events: auto;
  }

  :host(.conversation-list-item--has-actions) .conversation-list-item__title-row {
    padding-inline-end: var(--dimension-size-400);
  }
}
